
const ApproachHero = () => {
  return (
    <section className="relative min-h-[70vh] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f689ea174add5f916b1ecbe517d8a90a.jpg"
          alt="Precision Methodology"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/50"></div>
      </div>

      {/* X Pattern Overlay */}
      <div className="absolute inset-0 opacity-10">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="xPatternApproach" x="0" y="0" width="80" height="80" patternUnits="userSpaceOnUse">
              <line x1="0" y1="0" x2="80" y2="80" stroke="#10B981" strokeWidth="1" />
              <line x1="80" y1="0" x2="0" y2="80" stroke="#10B981" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#xPatternApproach)" />
        </svg>
      </div>

      {/* Floating X Elements */}
      <div className="absolute top-20 right-20 text-emerald-500/10 text-[180px] font-bold rotate-12">✕</div>
      <div className="absolute bottom-20 right-1/3 text-teal-500/5 text-[100px] font-bold -rotate-12">✕</div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32">
        <div className="max-w-3xl">
          <div className="mb-8">
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/10 border border-emerald-500/30 rounded-full text-emerald-400 text-xs font-semibold uppercase tracking-widest">
              OUR METHODOLOGY
            </span>
          </div>
          
          <h1 className="text-6xl lg:text-7xl font-extrabold text-white mb-8 leading-tight">
            Precision Before <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-400">Automation.</span>
          </h1>
          
          <p className="text-xl text-gray-300 leading-relaxed font-light max-w-2xl">
            We don't start with tools. We start with understanding where your business actually breaks — then we apply intelligence with purpose.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ApproachHero;
